import type { ApiStatus } from '../types';
import { formatDateShort } from '../utils/date';

interface StatsGridProps {
  status: ApiStatus;
}

export function StatsGrid({ status }: StatsGridProps) {
  return (
    <div className="stats-grid">
      <div className="stat-card">
        <div className="stat-label">System Status</div>
        <div className={`stat-value status-${status.status.toLowerCase()}`}>
          <span className="status-dot"></span>
          {status.status}
        </div>
      </div>
      <div className="stat-card">
        <div className="stat-label">Total Signals</div>
        <div className="stat-value">{status.total_recommendations.toLocaleString()}</div>
      </div>
      <div className="stat-card">
        <div className="stat-label">Last Updated</div>
        <div className="stat-value">{status.last_updated ? formatDateShort(status.last_updated) : 'Never'}</div>
      </div>
    </div>
  );
}
